// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"19":"ff4b0656","488":"d3d7916d","532":"ead376d6"}[chunkId] + ".chunk.js";
};